/* Worn & Loved — landing behaviour (no dependencies) */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function money(cents) {
    return '$' + (Math.round(cents) / 100).toFixed(2);
  }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    var track = $('.wl-gallery__track', root);
    if (!track) return;
    var slides = $$('.wl-gallery__slide', track);
    var dots = $$('.wl-gallery__dot', root);
    var thumbs = $$('.wl-gallery__thumb', root);
    function setActive(i) {
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    function go(i) {
      var s = slides[i];
      if (!s) return;
      track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      setActive(i);
    }
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        setActive(Math.min(Math.max(i, 0), slides.length - 1));
        ticking = false;
      });
    }, { passive: true });
    setActive(0);
  }

  /* ---------- Buy box ---------- */
  function initBuy() {
    var dataEl = document.getElementById('wl-product-data');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var variants = data.variants || [];
    var packs = data.packs || [];
    var colors = data.colors || [];
    var buy = document.getElementById('wl-buy');
    if (!buy) return;

    var initialVariant = variants.filter(function (v) { return String(v.id) === String(data.selectedVariantId); })[0];
    var state = {
      pack: initialVariant ? initialVariant.pack : data.defaultPack || (packs[0] && packs[0].name),
      color: initialVariant ? initialVariant.color : null
    };
    var adding = false;

    function packCount(name) { var n = parseInt(name, 10); return isNaN(n) ? 1 : n; }
    function packInfo(name) { for (var i = 0; i < packs.length; i++) { if (packs[i].name === name) return packs[i]; } return packs[0]; }
    function findVariant(pack, color) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.pack === pack && (color === null || v.color === color)) return v;
      }
      return null;
    }

    var packInputs = $$('input[name="wl-pack"]', buy);
    var colorInputs = $$('input[name="wl-color"]', buy);
    var colorStep = $('[data-wl-color-step]', buy);
    var colorLabel = $$('[data-wl-color-label]');
    var errorEls = $$('[data-wl-error]');

    function render() {
      var info = packInfo(state.pack);
      var v = findVariant(state.pack, state.color);
      var price = v ? v.price : info.price;
      var compare = v ? v.compare : info.compare;
      var n = packCount(state.pack);

      packInputs.forEach(function (inp) {
        var on = inp.value === state.pack;
        inp.checked = on;
        inp.closest('.wl-pack').classList.toggle('is-selected', on);
      });
      colorInputs.forEach(function (inp) {
        var on = inp.value === state.color;
        inp.checked = on;
        inp.closest('.wl-swatch').classList.toggle('is-selected', on);
      });

      $$('[data-wl-price]').forEach(function (el) { el.textContent = money(price); });
      $$('[data-wl-compare]').forEach(function (el) { el.textContent = compare > price ? money(compare) : ''; el.hidden = !(compare > price); });
      $$('[data-wl-save]').forEach(function (el) { el.textContent = compare > price ? 'You save ' + money(compare - price) : ''; });
      $$('[data-wl-each]').forEach(function (el) { el.textContent = n > 1 ? money(price / n) + ' per sheet' : ''; });
      colorLabel.forEach(function (el) { el.textContent = state.color || el.getAttribute('data-empty') || 'Choose a shade'; });
      var summary = state.pack + ' · ' + (state.color || 'Choose your shade');
      $$('[data-wl-summary]').forEach(function (el) { el.textContent = summary; });
      $$('[data-wl-add-label]').forEach(function (el) {
        if (el.parentElement.getAttribute('aria-busy') !== 'true') {
          el.textContent = state.color ? 'Add to cart' : 'Choose a shade';
        }
      });
      if (data.isProductPage && state.color && v && window.history.replaceState) {
        var selectionUrl = new URL(window.location.href);
        selectionUrl.searchParams.set('variant', String(v.id));
        window.history.replaceState(null, '', selectionUrl.toString());
      }
    }

    function clearErrors() { errorEls.forEach(function (el) { el.classList.remove('is-visible'); el.textContent = ''; }); }
    function showError(msg) { errorEls.forEach(function (el) { el.textContent = msg; el.classList.add('is-visible'); }); }

    function askForColor() {
      if (!colorStep) return;
      colorStep.classList.remove('is-attention');
      void colorStep.offsetWidth;
      colorStep.classList.add('is-attention');
      colorStep.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var first = colorInputs[0];
      if (first) { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }
    }

    function setBusy(on) {
      adding = !!on;
      $$('[data-wl-add]').forEach(function (b) {
        b.setAttribute('aria-busy', on ? 'true' : 'false');
        b.disabled = !!on;
        var label = $('[data-wl-add-label]', b);
        if (label) {
          if (on) { label.setAttribute('data-prev', label.textContent); label.textContent = 'Adding…'; }
          else if (label.getAttribute('data-prev')) { label.textContent = label.getAttribute('data-prev'); }
        }
      });
    }

    function addToCart() {
      if (adding) return;
      clearErrors();
      if (!state.color) { askForColor(); return; }
      var v = findVariant(state.pack, state.color);
      if (!v) { showError('Sorry, that option is not available right now.'); return; }
      if (!v.available) { showError('That shade is currently unavailable. Please choose another.'); return; }
      setBusy(true);
      var root = data.root || '/';
      if (root.slice(-1) !== '/') root += '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (j) { throw new Error((j && (j.description || j.message)) || 'Could not add to cart'); });
          window.location.href = root + 'cart';
        })
        .catch(function (err) {
          setBusy(false);
          showError((err && err.message) ? err.message : 'Something went wrong. Please try again.');
        });
    }

    packInputs.forEach(function (inp) {
      inp.addEventListener('change', function () { state.pack = inp.value; render(); });
    });
    colorInputs.forEach(function (inp) {
      inp.addEventListener('change', function () {
        state.color = inp.value;
        if (colorStep) colorStep.classList.remove('is-attention');
        render();
      });
    });

    $$('[data-wl-add]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); addToCart(); });
    });

    $$('[data-wl-pick-color]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var c = b.getAttribute('data-wl-pick-color');
        var inp = colorInputs.filter(function (i) { return i.value === c; })[0];
        if (inp) {
          inp.checked = true;
          inp.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (colorStep) colorStep.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    $$('[data-wl-pick-pack]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var p = b.getAttribute('data-wl-pick-pack');
        state.pack = p; render();
        buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    /* Sticky bar (phones): visible from the first screen, hidden only while
       the buy-box button or the final CTA is on screen */
    var sticky = document.getElementById('wl-sticky');
    var heroBtn = $('[data-wl-hero-add]', buy);
    var finalSec = document.getElementById('wl-final');
    if (sticky && heroBtn && 'IntersectionObserver' in window) {
      var heroVisible = false, finalVisible = false;
      var update = function () { sticky.classList.toggle('is-visible', !heroVisible && !finalVisible); };
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { heroVisible = en.isIntersecting; });
        update();
      }).observe(heroBtn);
      if (finalSec) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { finalVisible = en.isIntersecting; });
          update();
        }, { threshold: 0.15 }).observe(finalSec);
      }
    }

    window.addEventListener('pageshow', function () { setBusy(false); });
    render();
  }

  /* ---------- Cart count in header ---------- */
  function initCartCount() {
    var el = document.querySelector('[data-wl-cart-count]');
    if (!el) return;
    var n = parseInt(el.textContent, 10);
    el.hidden = !(n > 0);
  }

  function init() {
    $$('.wl-gallery').forEach(initGallery);
    initBuy();
    initCartCount();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
